import { PlaySimpleBalanceProps } from './types';
import { StyledPlaySimpleBalance } from './style';
import { formattingNumber } from '../../Helper/utils/utils';

const PlaySimpleBalance = ({ balance }: PlaySimpleBalanceProps) => {
    const defaultBalanceQuantityFormat = {
        billionShorthand: false,
        fractionalSeparator: '',
        milSeparator: ' ',
        millionShorthand: false,
        thousandShorthand: false
    };
    return (
        <StyledPlaySimpleBalance className="playSimple-balance">
            <img className="playSimple-balance__img" alt="balance" src={balance.image} />
            <div className="playSimple-balance__amount">
                <span>
                    {formattingNumber(
                        balance.amount,
                        defaultBalanceQuantityFormat
                    )}
                </span>
            </div>
        </StyledPlaySimpleBalance>
    );
};

export default PlaySimpleBalance;
